module.exports = __webpack_public_path__ + "img/text.0e9f29d1.png";